export function normalizePhoneFilterDigits(
  value: string | number | null | undefined,
  maxDigits = 10,
  stripLeadingUSCountryCode = true
): string {
  const raw = String(value ?? '').trim();
  const digits = raw.replace(/\D+/g, '');

  if (!digits) {
    return '';
  }

  // US country code handling for phone filters: ignore leading +1/1.
  const normalized = stripLeadingUSCountryCode && digits.length > maxDigits && digits.startsWith('1') ? digits.slice(1) : digits;
  return normalized.slice(0, maxDigits);
}


export function normalizeSearchValueForPhone(searchValue: string | null | undefined): string | null | undefined {
  if (searchValue == null || searchValue === '') {
    return searchValue;
  }
  const trimmed = String(searchValue).trim();
  const digits = trimmed.replace(/\D+/g, '');
  // If it looks like a phone number (7+ digits), normalize to digits-only for consistent matching
  if (digits.length >= 7) {
    return normalizePhoneFilterDigits(trimmed, 15, true);
  }
  return trimmed;
}
